import script from "./Home.vue?vue&type=script&lang=ts&setup=true"
export * from "./Home.vue?vue&type=script&lang=ts&setup=true"

import "./Home.vue?vue&type=style&index=0&id=cf079a76&scoped=true&lang=less"
import "./Home.vue?vue&type=style&index=1&id=cf079a76&lang=less"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf079a76"]])

export default __exports__